<!-- <img class="project-image" src="/assets/sinosuidal.gif"/> -->
<div class="personal-tagline">Critical thinking</div>
<div class="personal-tagline-desc">
    Is my mantra for software design.
</div>